// Entry point for Vite. Sets up client-side routing and mounts into #root.
//
// Routes:
//   /              → Landing page (public marketing)
//   /app           → NomLoop app (onboarding + planner)
//   /set-password  → First-time password setup after invite magic-link
//   /privacy       → Privacy Policy
//   /cookies       → Cookie Policy
//   /terms         → Terms & Conditions
//   *              → Landing page
//
// /partners, /brands, /sponsors and /api-interest were retired (mobile-only
// launch): they fall through to "*". The page files remain in src/pages/.

import React    from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import App              from "./NomLoop.jsx";
import LandingPage      from "./src/pages/LandingPage.jsx";
import PrivacyPage      from "./src/pages/PrivacyPage.jsx";
import CookiePage       from "./src/pages/CookiePage.jsx";
import TermsPage        from "./src/pages/TermsPage.jsx";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/"              element={<LandingPage />} />
        <Route path="/app"           element={<App />} />
        <Route path="/set-password"  element={<App />} />
        <Route path="/privacy"       element={<PrivacyPage />} />
        <Route path="/cookies"       element={<CookiePage />} />
        <Route path="/terms"         element={<TermsPage />} />
        <Route path="*"              element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
